import React, {useState} from 'react';
import './App.css';
import 'primereact/resources/themes/lara-light-amber/theme.css';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';
import Login from "./components/Login";
import MainScreen from "./components/MainScreen";
import {ToastContextProvider} from "./lib/contexts/ToastContext";
import {ClickStat} from "./lib/types/types";
import {BlockUI} from "primereact/blockui";

export interface User {
    username: string;
    locationTag: string;
    enableExtraOptions: boolean
}

const App = () => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const [clickStats, setClickStats] = useState<ClickStat>();
    const [loggedUser, setLoggedUser] = useState<User>();
    const [blockUi, setBlockUi] = useState<boolean>(false);

    const handleLogin = (clickStats: ClickStat, user: User) => {
        setIsUserLoggedIn(true);
        setLoggedUser(user);
        setClickStats(clickStats);
    }

    return <>
        <ToastContextProvider>
            {isUserLoggedIn ?
                <BlockUI style={{height: "100vh"}} blocked={blockUi}>
                    <MainScreen blockUi={setBlockUi} clickStats={clickStats!} user={loggedUser!}/>
                </BlockUI>
                :
                <Login onSuccessfulLogin={handleLogin}/>
            }
        </ToastContextProvider>
    </>
}

export default App;
